<template>
  <transition name="fade">
    <div
      v-show="isShow"
      class="next-btn flex justify-center items-center"
      :class="{ 'btn-hover-animation': isShow }"
      @click.stop="$emit('nextbtn-click')"
    >
      <img src="./assets/next.svg" alt="" />
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class NextBtn extends Vue {
  @Prop({}) isShow!: boolean;
}
</script>

<style lang="scss" scoped>
.next-btn {
  position: absolute;
  bottom: 48px;
  width: 64px;
  height: 64px;
  background: linear-gradient(146.61deg, #524eff 50%, #605bff 79.72%),
    linear-gradient(rgba(82, 78, 255, 1), rgba(96, 91, 255, 1), rgba(255, 255, 255, 0));
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  border-radius: 50%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  animation: 1.6s ease-in-out infinite breath;
}
.btn-hover-animation {
  &:hover,
  &:active {
    opacity: 0.85;
  }
}
</style>
